import { AxisCtrParams } from '../types';
import AxisLabels from './axisLabels';
export default class Axis {
  domain: any;
  scale: any;
  range: any;
  loc: string;
  labels: AxisLabels;

  constructor(params?: AxisCtrParams) {
    if (params?.domain) this.domain = params.domain;
    if (params?.scale) this.scale = params.scale;
    if (params?.range) this.range = params.range;
    if (params?.loc) this.loc = params.loc;

    this.labels = new AxisLabels();
  }

  setDomain(val: any) {
    this.domain = val;
  }

  setScale(val: any) {
    this.scale = val;
  }

  setRange(val: any) {
    this.range = val;
  }

  setLoc(val: any) {
    this.loc = val;
  }
}
